import React from 'react';
import Spinner, { SpinnerColor } from '../../../generic-components/Spinner';
import { STYLES } from '../consts';

export const PreLoad = () => (
  <div className={STYLES.PRE_LOAD.wrapper}>
    <Spinner spinnerColor={SpinnerColor.Blue} height='3rem' width='3rem' />
  </div>
);
